import React from 'react';
import { Badge } from '@mui/material';
import { styled } from '@mui/material/styles';
import { slotShouldForwardProp } from '@mui/material/styles/styled';

import { uiColors } from '../../common/styles';

const StyledFramiBadge = styled(Badge, {
    shouldForwardProp: (prop) => slotShouldForwardProp(prop) && prop !== 'badgeStyle',
})(({ badgeStyle }) => ({
    '& .MuiBadge-badge': {
        color: 'white',
        backgroundColor: badgeStyle?.backgroundColor ?? `${uiColors.PRIMARY}`,
        right: badgeStyle?.right ?? '7px',
        top: badgeStyle?.top ?? '32px',
        scale: badgeStyle?.scale ?? '70%',
        padding: 0,
        ...badgeStyle,
    },
}));

const FramiBadge = ({ badgeStyle, ...restProps }) => {
    return <StyledFramiBadge badgeStyle={badgeStyle} {...restProps}></StyledFramiBadge>;
};

export default FramiBadge;
